import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({ children }) {
    const [cookies] = useCookies(["token"]);
    const token = cookies.token;
    const [maintenance, setMaintenance] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const checkAccess = async () => {

            try {

                if (!token) {
                    setMaintenance(false);
                    return;
                }

                const decoded = jwtDecode(token);

                // Vérification expiration JWT
                if (decoded.exp * 1000 < Date.now()) {
                    return;
                }

                const res = await fetch(
                    "https://api.industriegaming.fr/api/script/request/getall",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (res.status === 503) {
                    console.log("Site en maintenance");
                    setMaintenance(true);
                }

            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }

        };

        checkAccess();

    }, [token]);

    if (loading) {
        return <div>Chargement...</div>;
    }

    if (maintenance) {
        return <Navigate to="/maintenance" replace />;
    }

    if (!token) {
        return <Navigate to="/" replace />;
    }

    try {
        const decoded = jwtDecode(token);

        // Vérifier l'expiration
        if (decoded.exp * 1000 < Date.now()) {
            return <Navigate to="/" replace />;
        }

    } catch (err) {
        // Token illisible → on dégage
        return <Navigate to="/" replace />;
    }

    return children;
}
